module.exports = __webpack_public_path__ + "static/img/szafa_dso_45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_dso_45.svg
// module id = 2E06
// module chunks = 0